export const SEARCH_ANIMES = 'SEARCH_ANIMES';
export const GET_ANIME = 'GET_ANIME';
export const CLEAR_ANIMES = 'CLEAR_ANIMES';
export const GET_GENRES = 'GET_GENRES';
export const GET_GENRE_ANIMES = 'GET_GENRE_ANIMES';
export const SET_LOADING = 'SET_LOADING';
export const CLEAR_LOADING = 'CLEAR_LOADING';
export const ADD_LIST_ITEM = 'ADD_LIST_ITEM';
export const GET_STORAGE = 'GET_STORAGE';
export const REMOVE_LIST_ITEM = 'REMOVE_LIST_ITEM';
export const SET_GENRE = 'SET_GENRE';

